import { render } from "./ExamNewOffcanvas.vue?vue&type=template&id=a6a1073c&scoped=true"
import script from "./ExamNewOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamNewOffcanvas.vue?vue&type=script&lang=js"

import "./ExamNewOffcanvas.vue?vue&type=style&index=0&id=a6a1073c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a1073c"]])

export default __exports__